import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EditStartProjectDetailInput, GetStartProjectDetailsInput, ProjectChartResult, ProjectStatus, Result, ResultList, SingleResult, StartProjectDetailInput, StartProjectDetailListResult, StartProjectDetailResult, StartProjectLogResult } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class StartProjectDetailService {

  constructor(private httpClient: HttpClient) { }

  public addStartProjectDetail(startProjectDetailInput: StartProjectDetailInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'StartProjectDetail/AddStartProjectDetail', startProjectDetailInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editStartProjectDetail(id: number, startProjectDetailInput: EditStartProjectDetailInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'StartProjectDetail/EditStartProjectDetail?id=' + id, startProjectDetailInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteStartProjectDetail(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'StartProjectDetail/DeleteStartProjectDetail?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getStartProjectDetailHistory(id: number): Promise<ResultList<StartProjectLogResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'StartProjectDetail/GetStartProjectDetailHistory?startProjectDetailId=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<StartProjectLogResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<StartProjectLogResult>(), result.error));
  }

  public getStartProjectDetail(startProjectId: number, token: string): Promise<ResultList<StartProjectDetailResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'StartProjectDetail/GetStartProjectDetail?startProjectId=' + startProjectId, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<StartProjectDetailResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<StartProjectDetailResult>(), result.error));
  }

  public getStartProjectDetailList(getStartProjectDetailsInput: GetStartProjectDetailsInput, token: string): Promise<ResultList<StartProjectDetailListResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'StartProjectDetail/GetStartProjectDetailList', getStartProjectDetailsInput, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<StartProjectDetailListResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<StartProjectDetailListResult>(), result.error));
  }

  public getStartProjectDetailListExportToExcel(getStartProjectDetailsInput: GetStartProjectDetailsInput): Promise<SingleResult<Uint8Array>> {
    return this.httpClient.post(Utility.serviceAddress + 'StartProjectDetail/GetStartProjectDetailListExportToExcel', getStartProjectDetailsInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new SingleResult<Uint8Array>(Uint8Array), result))
      .catch(result => plainToClassFromExist(new SingleResult<Uint8Array>(Uint8Array), result.error));
  }

  public getAllStartProjectDetailReport(token: string): Promise<ResultList<ProjectChartResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'StartProjectDetail/GetAllStartProjectDetailReport', Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ProjectChartResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ProjectChartResult>(), result.error));
  }

  public updateAssignee(id: number, employeeId: number): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'StartProjectDetail/UpdateAssignee?id=' + id, employeeId, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public updateProjectStatus(id: number, projectStatus: ProjectStatus): Promise<Result> {
    return this.httpClient.patch(Utility.serviceAddress + 'StartProjectDetail/UpdateProjectStatus?id=' + id, projectStatus, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }
}
